import { Injectable } from '@angular/core';
import { ConfigurationService } from './configuration.service';
import { Observable, from, switchMap } from 'rxjs';
import { CognitoService } from './cognito.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Job } from '../models/job.interface';
import { JobResult } from '../models/job_result.interface';
import { DriftConfiguration } from '../models/configuration.interface';

@Injectable({
  providedIn: 'root'
})
export class ResearchAssistantService {
  config: DriftConfiguration;

  constructor(
    private http: HttpClient,
    private configurationService: ConfigurationService,
    private cognitoService: CognitoService
  ) {
    this.config = this.configurationService.getConfiguration();
  }

  // TODO: Add Type
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public launchJob(prompt: string, collection: string, documents: any) {
    return from(this.cognitoService.getUserEmail()).pipe(
      switchMap(email => {
        const requestBody = { prompt, user: email, collection, documents };
        return this.http.post(`${this.config.driftApi}/research-assistant`, requestBody);
      })
    );
  }

  public publishJob(job_id: string, publish: boolean) {
    const requestBody = { job_id, publish };
    return this.http.post(`${this.config.driftApi}/research-assistant-publish`, requestBody);
  }

  public deleteJob(job_id: string) {
    const requestBody = { job_id };
    return this.http.post(`${this.config.driftApi}/research-assistant-delete-job`, requestBody);
  }

  public launchPreview(prompt: string) {
    return from(this.cognitoService.getUserEmail()).pipe(
      switchMap(email => {
        const requestBody = { prompt, user: email };
        return this.http.post(`${this.config.driftApi}/research-assistant-preview`, requestBody);
      })
    );
  }

  public getJobs(): Observable<Job[]> {
    return from(this.cognitoService.getUserEmail()).pipe(
      switchMap(email => {
        const params = new HttpParams().set('user', email);
        return this.http.get<Job[]>(`${this.config.driftApi}/research-assistant-jobs`, { params });
      })
    );
  }

  public getPublishedJobs(): Observable<Job[]> {
    return this.http.get<Job[]>(`${this.config.driftApi}/research-assistant-published-jobs`);
  }

  public getJobResult(job_id: string): Observable<JobResult[]> {
    const params = new HttpParams().set('job_id', job_id);
    return this.http.get<JobResult[]>(`${this.config.driftApi}/research-assistant-job-result`, { params });
  }
}
